//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { IInstagramUserStatsModel } from '@instagram-account/reducers/instagram-user-stats-model';
import { INSTAGRAM_USER_STATS_ACTIONS } from '../instagram-account-constants/instagram-user-stats-constants';

const initialState: IInstagramUserStatsModel = {
  isFetchingSummaryUserStats: false,
  aggregateSummaryUserStats: undefined,
  aggregateSummaryUserComparisonStats: undefined,
  dailySummaryUserStats: [],

  isFetchingSummaryTrafficStats: false,
  trafficByChannelStats: [],
  referralStats: undefined,

  isFetchingHMSAudienceInsightsStart: false,
  hmsAudienceInsightsStartDate: undefined,
  summaryDefaultDateRange: undefined,
};

export default function InstagramUserStatsReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case INSTAGRAM_USER_STATS_ACTIONS.REQUEST_SUMMARY_INSTAGRAM_USER_STATS:
      return Object.assign({}, state, {
        isFetchingSummaryUserStats: true,
      });
    case INSTAGRAM_USER_STATS_ACTIONS.RECEIVE_SUMMARY_INSTAGRAM_USER_STATS:
      return Object.assign({}, state, {
        isFetchingSummaryUserStats: false,
        aggregateSummaryUserStats: action.payload.aggregateStats,
        aggregateSummaryUserComparisonStats:
          action.payload.aggregateComparisonStats,
        dailySummaryUserStats: action.payload.trendStats,
      });
    case INSTAGRAM_USER_STATS_ACTIONS.REQUEST_SUMMARY_TRAFFIC_STATS:
      return Object.assign({}, state, {
        isFetchingSummaryTrafficStats: true,
      });
    case INSTAGRAM_USER_STATS_ACTIONS.RECEIVE_SUMMARY_TRAFFIC_STATS:
      return Object.assign({}, state, {
        isFetchingSummaryTrafficStats: false,
        trafficByChannelStats: action.payload.trafficByChannelStats,
        referralStats: action.payload.referralStats,
      });
    case INSTAGRAM_USER_STATS_ACTIONS.REQUEST_HMS_AUDIENCE_INSIGHTS_START:
      return Object.assign({}, state, {
        isFetchingHMSAudienceInsightsStart: true,
      });
    case INSTAGRAM_USER_STATS_ACTIONS.RECEIVE_HMS_AUDIENCE_INSIGHTS_START:
      return Object.assign({}, state, {
        isFetchingHMSAudienceInsightsStart: false,
        hmsAudienceInsightsStartDate: action.payload.date,
        summaryDefaultDateRange: action.payload.dateRange,
      });
    default:
      return state;
  }
}
